import { useTheme } from '@emotion/react';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { ForwardedRef, forwardRef } from 'react';
import { Container, Label, StyledCheckbox } from './Checkbox.styles';
import { CheckboxProps } from './Checkbox.types';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';

const Checkbox: React.FC<CheckboxProps> = forwardRef(
  ({ checked, label, id, disabled, indeterminate = false, testId, isBold, ...props }, ref: ForwardedRef<HTMLInputElement>) => {
    const theme = useTheme();
    const Icon = (props: { indeterminate?: boolean; checked?: boolean }) => {
      if (props.indeterminate || !checked) {
        return <RemoveOutlinedIcon htmlColor={theme.colors.white} fontSize='small' />
      }
      return <CheckOutlinedIcon htmlColor={theme.colors.white} fontSize='small' />

    };
    return (
      <Container>
        <StyledCheckbox
          {...props}
          type='checkbox'
          checked={checked}
          ref={ref}
          id={id}
          aria-checked={checked ? checked : indeterminate ? 'mixed' : 'false'}
          aria-disabled={disabled ? 'true' : 'false'}
          disabled={disabled}
          indeterminate={indeterminate && !checked}
          data-testid={testId}
        />
        <Icon indeterminate={indeterminate}/>
        <Label bold={isBold} htmlFor={id}>{label}</Label>
      </Container>
    );
  }
);

export default Checkbox;
